export const getSettingsBaseUrl = () => '/live-messages-settings';